<script lang="ts">
    import {Component, mixins, toNative} from 'vue-facing-decorator'
    import BookingPageBase from '~src/components/parts/bookingPageBase.src'
    import {InsuranceStoreMixin} from '@/mixins/InsuranceStoreMixin.vue'
    import {callComponentMethod} from '~/utils/vue-class-helpers'

    @Component({mixins: [BookingPageBase]})
    export class InsuranceBookingPageLayout extends mixins(InsuranceStoreMixin) {
        initTourists(sr, tourists) {
            const touristsList = callComponentMethod(this, BookingPageBase, 'initTourists', sr, tourists)
            touristsList.forEach(tourist => {
                tourist.address = null
                tourist.passportNumber = null
            })
            return touristsList
        }

        // TODO [P5] Need refactoring and implement prepareBookRequest in adapter functions
        prepareBookRequest(specifiedTouristBookingFields, includeOptionalTourists = false) {
            const prepareBookRequest = callComponentMethod(
                this,
                BookingPageBase,
                'prepareBookRequest',
                specifiedTouristBookingFields,
                includeOptionalTourists
            )
            for (const tourist of prepareBookRequest.tourists) {
                delete tourist.passport
            }
            return prepareBookRequest
        }

        get productSearchPageName() {
            return 'insuranceSearch'
        }

        get productConfirmationPageName() {
            return 'insuranceConfirmation'
        }

        get productName() {
            return 'insurance'
        }

        get productBookingPageName() {
            return 'insuranceBooking'
        }

        get corporatePolicyType() {
            return null
        }

        get touristToken() {
            return 'tourist'
        }
    }

    export default {...toNative(InsuranceBookingPageLayout), ssrRender: BookingPageBase.ssrRender}
</script>
